exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-content-wrapper-logo-logo-styles__whiteLabelLogo {\n  min-width: 15.6rem;\n  max-width: 32rem;\n  min-height: 5.6rem;\n  max-height: 6.4rem;\n  object-fit: contain;\n}\n", ""]);

// Exports
exports.locals = {
	"whiteLabelLogo": "src-content-wrapper-logo-logo-styles__whiteLabelLogo"
};